/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S42_TitleInputs */

const es_tyc_obligations_s42_title = /** @type {(inputs: Tyc_Obligations_S42_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.2 Uso Prohibido`)
};

const en_tyc_obligations_s42_title = /** @type {(inputs: Tyc_Obligations_S42_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.2 Prohibited Use`)
};

/**
* | output |
* | --- |
* | "4.2 Prohibited Use" |
*
* @param {Tyc_Obligations_S42_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s42_title = /** @type {((inputs?: Tyc_Obligations_S42_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S42_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s42_title(inputs)
	return en_tyc_obligations_s42_title(inputs)
});
export { tyc_obligations_s42_title as "tyc.obligations.s42_title" }